import { API_ROOT_URL, OP_GET_MATERIAL_API, OP_GET_TEXTURES_API, TEXTURE_API } from '../../config/constant/apiConstant';
import {
  addTextureSuccess,
  fetchTextureListFailed,
  fetchTextureListStart,
  fetchTextureListSuccess,
  setTextureData,
} from '../../redux/slicers/textures/textureSlicer';
import { createDeleteApiAction, createGetListAction, createUpdateApiAction } from '../apiGenerator';
import { errorToast, successToast } from '../../helpers/toastHelper';

import { MODEL_TYPES } from '../../constants/constants';
import api from '../../helpers/axiosHelper';
import { createListApiRequest } from '../../helpers/apiHelper';
import { paginatedTexturesActions } from '../../redux/slicers/textures/paginatedTexturesSlicer';
import { showDialogForTextureLimitExceeds } from '../../screens/MyProductsTextures';
import { texturesActions } from '../../redux/slicers/texturesSlicer';
import { uploadsPageActions } from '../../redux/slicers/uploadsPageSlicer';
import { dashboardTabMaterialsActions } from '../../redux/slicers/dashboardTabMaterialSlicer';
import { MATERIAL_API } from '../../helpers/api';
import { isInternalUser } from '../../helpers/jsHelper';

/**
 * @method POST
 * @desc Uploads texture to the server
 */
export const TextureAddApi = (formData, cb) => (dispatch) => {
  dispatch(paginatedTexturesActions.setAddLoading(true));

  return api()
    .root(API_ROOT_URL)
    .post(TEXTURE_API)
    .data(formData)
    .success((res) => {
      dispatch(TextureFetchApi());
      dispatch(addTextureSuccess(res.data));
      dispatch(paginatedTexturesActions.addSuccess(res.data));
      successToast('Texture added successfully');
    })
    .badRequest400(() => {})
    .error((e) => {
      if (e.message?.name?.[0]) {
        errorToast(e.message?.name?.[0]);
      } else {
        if(e?.message?.toLowerCase()?.includes('limit has been reached')) {
          showDialogForTextureLimitExceeds();
        } else {
          errorToast('Some error occured');
        }
      }
      dispatch(paginatedTexturesActions.addStart());
    })
    .finally(() => {
      dispatch(paginatedTexturesActions.setAddLoading(false));
    })
    .send(cb);
};

/**
 * @method GET
 * @desc Fetch list of textures for the user
 */
export const TextureFetchApi =
  ({ search, sort = '-created_at' } = {}) =>
  (dispatch) => {
    let API_URL = TEXTURE_API;

    API_URL = search ? `${API_URL}?search=${search}` : API_URL;
    API_URL = sort ? `${API_URL}?sort=${sort}` : API_URL;

    api()
      .root(API_ROOT_URL)
      .get(API_URL)
      .success((data) => dispatch(setTextureData(data)))
      .error((error) => console.error('Error occured: ', error.message))
      .send();
  };

export const TextureFetchApiV2 = createListApiRequest({
  url: TEXTURE_API,
  startAction: fetchTextureListStart,
  successAction: fetchTextureListSuccess,
  errorAction: fetchTextureListFailed,
});

export const TextureEditV2Api = createUpdateApiAction({
  actions: paginatedTexturesActions,
  endpointUrl: TEXTURE_API,
});

export const TextureEditV2ApiWithProgress = createUpdateApiAction({
  actions: paginatedTexturesActions,
  endpointUrl: TEXTURE_API,
  progress: true,
});

export const getTextureListApi = createGetListAction({
  endpoint: TEXTURE_API,
  actions: paginatedTexturesActions,
});

export const getTexturesPageApi = createGetListAction({
  endpoint: TEXTURE_API,
  skipBrandFilter: true,
  actions: texturesActions,
  setGlobalSidebarFilters: true,
  parseSidefilter: (sidefilter) => {
    
    const updatedFilters = Object.assign({}, sidefilter);
    const categoryIndex = updatedFilters.filterlabels.findIndex(a => a.label_name.toLowerCase() === 'categories');
    if(categoryIndex !== -1) {
      updatedFilters.filteroptions = [
        {
          id: 'ua', 
          name: 'Unassigned', 
          filter_label: updatedFilters.filterlabels[categoryIndex]?.id
        },
        ...sidefilter.filteroptions
      ]
    }

    return updatedFilters
  }
});

export const getMaterialsPageApi = createGetListAction({
  endpoint: MATERIAL_API,
  skipBrandFilter: true,
  actions: dashboardTabMaterialsActions,
  setGlobalSidebarFilters: true,
  parseSidefilter: (sidefilter) => {
    
    const updatedFilters = Object.assign({}, sidefilter);
    const categoryIndex = updatedFilters.filterlabels.findIndex(a => a.label_name.toLowerCase() === 'categories');
    if(categoryIndex !== -1) {
      updatedFilters.filteroptions = [
        {
          id: 'ua', 
          name: 'Unassigned', 
          filter_label: updatedFilters.filterlabels[categoryIndex]?.id
        },
        ...sidefilter.filteroptions
      ]
    }

    return updatedFilters
  }
});

export const getUploadsPageApi = createGetListAction({
  endpoint: TEXTURE_API,
  skipBrandFilter: true,
  actions: uploadsPageActions,
  // setGlobalSidebarFilters: true,
});


export const getTexturesPageOptimizeApi = createGetListAction({
  endpoint: OP_GET_TEXTURES_API,
  skipBrandFilter: true,
  actions: texturesActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.TEXTURE,
  parseSidefilter: (sidefilter) => {
    
    const updatedFilters = Object.assign({}, sidefilter);
    const categoryIndex = updatedFilters.filterlabels.findIndex(a => a.label_name.toLowerCase() === 'categories');
    if(categoryIndex !== -1) {
      updatedFilters.filteroptions = [
        {
          id: 'ua', 
          name: 'Unassigned', 
          filter_label: updatedFilters.filterlabels[categoryIndex]?.id
        },
        ...sidefilter.filteroptions
      ]
    }

    return updatedFilters
  }
});

export const getMaterialPageOptimizeApi = createGetListAction({
  endpoint: OP_GET_MATERIAL_API,
  skipBrandFilter: !isInternalUser(),
  actions: dashboardTabMaterialsActions,
  setGlobalSidebarFilters: true,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.MATERIAL,
  parseSidefilter: (sidefilter) => {
    
    const updatedFilters = Object.assign({}, sidefilter);
    const categoryIndex = updatedFilters.filterlabels.findIndex(a => a.label_name.toLowerCase() === 'categories');
    if(categoryIndex !== -1) {
      updatedFilters.filteroptions = [
        {
          id: 'ua', 
          name: 'Unassigned', 
          filter_label: updatedFilters.filterlabels[categoryIndex]?.id
        },
        ...sidefilter.filteroptions
      ]
    }

    return updatedFilters
  }
});

export const getUploadsPageOptimizeApi = createGetListAction({
  endpoint: OP_GET_TEXTURES_API,
  skipBrandFilter: true,
  actions: uploadsPageActions,
  useOptimizedAPI: true,
  modelType: MODEL_TYPES.UPLOADS,
  setGlobalSidebarFilters: true,
});

export const updateTextureApi = createUpdateApiAction({
  actions: texturesActions,
  endpointUrl: TEXTURE_API,
});

export const updateDashboardMaterialsApi = createUpdateApiAction({
  actions: dashboardTabMaterialsActions,
  endpointUrl: OP_GET_MATERIAL_API,
});

export const updateUploadApi = createUpdateApiAction({
  actions: uploadsPageActions,
  endpointUrl: TEXTURE_API,
});

export const deleteTextureAPI = createDeleteApiAction({
  actions: texturesActions,
  endpointUrl: TEXTURE_API,
  successMessage: 'Deleted',
  optimistic: false,
});

export const deleteDashboardMaterialAPI = createDeleteApiAction({
  actions: dashboardTabMaterialsActions,
  endpointUrl: OP_GET_MATERIAL_API,
  successMessage: 'Deleted',
  optimistic: false,
});

export const deleteUploadAPI = createDeleteApiAction({
  actions: uploadsPageActions,
  endpointUrl: TEXTURE_API,
  successMessage: 'Deleted',
  optimistic: false,
});
